resolveSelectionSet